import { createContext } from "react";

export const LayoutContentContext = createContext(null);
